var antPrefixCls = '.ant-divider';
var dividerStyleFn = function dividerStyleFn(token) {
  var _horizontal, _ref;
  return _ref = {}, _ref[antPrefixCls] = {
    borderBlockStart: "1px solid " + token.colorBorderSecondary,
    '&-horizontal': (_horizontal = {
      margin: token.marginMD + "px 0"
    }, _horizontal["&" + antPrefixCls + "-with-text"] = {
      borderBlockStart: "0 " + token.colorBorderSecondary,
      margin: token.marginMD + "px 0"
    }, _horizontal),
    '&-vertical': {
      borderInlineStart: '1px solid #CACACC'
    }
  }, _ref;
};

export { dividerStyleFn };
